import React from 'react';
import classNames from 'classnames/bind';
import { RenderParams, NodeModel } from '@minoru/react-dnd-treeview';
import { useLocation, useSearchParams } from 'react-router-dom';

import { Tag } from 'types/tag';

import styles from './TagsTree.module.scss';

const c = classNames.bind(styles);

export type TagsTreeStaticItemProps = RenderParams & {
  className?: string;
  node: NodeModel<Tag>;
};

function isStaticLinkActive(
  id: string | number,
  searchParams: URLSearchParams
) {
  if (id === 'none') {
    return searchParams.get('unlabeled');
  }

  if (id === 'all') {
    return !searchParams.has('tag') && !searchParams.has('unlabeled');
  }

  return false;
}

export function TagsTreeStaticItem({
  className,
  node: { id, text },
}: TagsTreeStaticItemProps) {
  const { pathname } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const linkParams = new URLSearchParams(searchParams);

  linkParams.delete('tag');

  if (id === 'all') {
    linkParams.delete('unlabeled');
  } else if (id === 'none') {
    linkParams.set('unlabeled', 'true');
  }

  // Override click handler for ?tag=id link to prevent page reload
  // and keep all other functionalities of the link (copy link, open in new tab)
  function handleLinkClick(event: React.MouseEvent<HTMLAnchorElement>) {
    event.preventDefault();
    setSearchParams(linkParams);
  }

  return (
    <div
      className={c(className, 'item', 'interactive', {
        active: isStaticLinkActive(id, searchParams),
      })}
    >
      <a
        href={`${pathname}?${linkParams.toString()}`}
        className={c('item-link')}
        onClick={handleLinkClick}
      >
        {text}
      </a>
    </div>
  );
}
